(() => {
    const hero = document.querySelector('[data-animated-hero]');
    if (!hero) return;

    // WebM first (smaller), MP4 as fallback for browsers without VP9 support.
    const webmSrc = hero.getAttribute('data-animated-hero-src-webm');
    const mp4Src = hero.getAttribute('data-animated-hero-src-mp4');
    if (!webmSrc && !mp4Src) return;

    // Respect the user's motion preference — the poster image stays and the
    // video is never downloaded.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    const poster = hero.querySelector('img');

    const video = document.createElement('video');
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.preload = 'auto';
    // iOS Safari only allows inline autoplay when the `muted` and `playsinline`
    // content attributes are present — the JS properties alone are not enough.
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.setAttribute('tabindex', '-1');
    // Same dimensions as the poster — sits on top of it, so no layout shift.
    video.className = 'absolute inset-0 w-full h-full object-cover z-0';

    const addSource = (src, type) => {
        if (!src) return;
        const source = document.createElement('source');
        source.src = src;
        source.type = type;
        video.appendChild(source);
    };
    addSource(webmSrc, 'video/webm');
    addSource(mp4Src, 'video/mp4');

    // Place the video directly after the poster so it paints on top of it
    // (both are z-0; the content layer above stays z-[1]).
    if (poster) {
        poster.insertAdjacentElement('afterend', video);
    } else {
        hero.insertBefore(video, hero.firstChild);
    }

    const play = video.play();
    if (play && typeof play.catch === 'function') {
        // Autoplay was blocked — the poster image remains as the fallback.
        play.catch(() => {});
    }
})();
